"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDrawFeatures = void 0;
var _react = require("react");
var _styledLib = require("@caps-mobile/styled-lib");
var _hooks = require("@algo/hooks");
var _commonLib = require("@caps-mobile/common-lib");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// Draws the current list of polygons to the HereMap
var useDrawFeatures = function useDrawFeatures(map, features, featureCallback) {
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    currentMapObjects = _useState2[0],
    setCurrentObjects = _useState2[1];
  var prevFeatures = (0, _hooks.usePrevious)(features);
  (0, _react.useEffect)(function () {
    if (map && features) {
      if (features.length > 0 && (!prevFeatures || !(0, _commonLib.arraysAreEqual)(features, prevFeatures))) {
        var objectList = [];
        features.map(function (feature) {
          var reader = new H.data.geojson.Reader(undefined,
          // optional url string (to a geojson file)
          {
            disableLegacyMode: true,
            style: function style(mapObject) {
              if (mapObject instanceof H.map.Polygon) {
                mapObject.setStyle({
                  fillColor: (0, _styledLib.rgbaBuilder)(feature.properties.category.fillColor),
                  strokeColor: (0, _styledLib.rgbaBuilder)(feature.properties.category.strokeColor),
                  lineWidth: 2
                });
                mapObject.addEventListener("tap", function () {
                  return featureCallback(feature);
                });
                objectList.push(mapObject);
              } else if (mapObject instanceof H.map.Group) {
                mapObject.getObjects().forEach(function (object) {
                  if (object instanceof H.map.Polygon) {
                    object.setStyle({
                      fillColor: (0, _styledLib.rgbaBuilder)(feature.properties.category.fillColor),
                      strokeColor: (0, _styledLib.rgbaBuilder)(feature.properties.category.strokeColor),
                      lineWidth: 2
                    });
                    object.addEventListener("tap", function () {
                      return featureCallback(feature);
                    });
                    objectList.push(mapObject);
                  }
                });
              }
            }
          });
          reader.parseData(feature);
          reader = null;
        });
        if (currentMapObjects && currentMapObjects.length > 0) map.removeObjects(currentMapObjects);
        map.addObjects(objectList);
        setCurrentObjects(currentMapObjects);
      }
    }
  }, [map, features, currentMapObjects]);
};
exports.useDrawFeatures = useDrawFeatures;